import { apiClient } from './client';
import { trackEvent } from './tracking';

function websiteDomain() {
  return window.location.hostname.toLowerCase().replace(/^preview\./, '').replace(/^www\./, '');
}
export type PublishedForm = {
  key: string;
  name: string;
  fields: Array<{ key: string; label: string; type: string; required?: boolean; options?: unknown }>;
  settings: Record<string, unknown>;
};
/** Public endpoints only: draft schemas are never exposed through this client. */
export async function getPublishedForm(key: string): Promise<PublishedForm> {
  const response = await apiClient.get<PublishedForm>(`/web/forms/${encodeURIComponent(key)}`, {
    headers: { 'X-Website-Domain': websiteDomain() },
  });
  return response.data;
}
export async function submitPublishedForm(key: string, contents: Record<string, unknown>): Promise<{ id: number; message: string }> {
  const response = await apiClient.post(`/web/forms/${encodeURIComponent(key)}/submissions`, { contents }, {
    headers: { 'X-Website-Domain': websiteDomain() },
  });
  trackEvent('form_submit');
  return response.data;
}

/** Newsletter subscriptions are stored in the CMS Submissions module. */
export async function subscribeToEmailUpdates(email: string): Promise<{ id: number; message: string }> {
  const response = await apiClient.post('/web/subscribe', { email }, {
    headers: { 'X-Website-Domain': websiteDomain() },
  });
  trackEvent('email_subscribe');
  return response.data;
}
